import { z } from 'zod';
import i18n from '../i18n';
import { MedtechUserV3 } from './users';

export const TEMPLATE_STATUS = {
  draft: 'draft',
  effective: 'effective',
  superseded: 'superseded',
  archived: 'archived',
} as const;

export type TemplateStatus = keyof typeof TEMPLATE_STATUS;
export const TEMPLATE_STATUSES = Object.values(TEMPLATE_STATUS);

export type ParentCompany = {
  id: number;
  name: string;
  status: string;
};

export type TemplateOwner = Pick<MedtechUserV3, 'user_id' | 'usercompany_id' | 'full_name'>;

export type Template = {
  id: number;
  template_uuid: string;
  name: string;
  prefix: string;
  company_id: number;
  status: TemplateStatus;
  version: number;
  created_time: Date;
  modified_time?: Date;
  owner_full_name?: string;
  owner?: TemplateOwner;
  parent?: ParentCompany | null;
  tag_ids?: number[];
};

export const ZCreateTemplateSchema = z.object({
  title: z
    .string({
      required_error: i18n.t('common.validation.titleRequired'),
    })
    .trim()
    .min(1, i18n.t('common.validation.titleRequired')),
  prefix: z
    .string({
      required_error: i18n.t('common.validation.prefixRequired'),
    })
    .trim()
    .min(1, i18n.t('common.validation.prefixRequired'))
    .refine((v) => v.match(/^[0-9a-zA-z]+$/), i18n.t('common.validation.prefixFormat')),
  tag_ids: z.array(z.number()).default([]),
});
export type CreateTemplateSchema = z.infer<typeof ZCreateTemplateSchema>;
